<script>

	import { mapState } from 'vuex'

	import './style.scss'

	export default {
		name: 'notification',
		computed: mapState({
			'show': state => state.user.notification.show,
			'type': state => state.user.notification.type,
			'message': state => state.user.notification.message,
			'duration': state => state.user.notification.duration,
		}),
	}
</script>

<template>
	<div :class='{ notification: true, show, [type]: type }'>
		<div class='badge'>
			{{ type }}
		</div>
		<p v-html='message' />
		<div class='close' @click='$eventHub.$emit("notification", { show: false })'>
			<i class='ion-close' />
		</div>
	</div>
</template>


// WEBPACK FOOTER //
// src/components/Notification/Notification.vue